import React from 'react'

function WhyImarikaChamaa() {
  return (
    <div>



Superior returns: Imarika ensures that you earn competitive returns on your investment as the underlying fund is structured and managed to offer competitive returns of 8 - 12% per annum. In case of poor market performance, the product has a minimum guaranteed return of 5% per annum on maturity.
<br></br>
<br></br>


Monthly Statements: Each month, a statement is sent to the individual member as well as a Consolidated chamaa statement sent to the Treasurer or appointed chamaa member
<br></br>
Free Life Insurance: Imarika provides each member with Free Life Insurance cover of Kes 50,000
<br></br>
Optional Partial Withdrawals: As the fund accumulates, you can make free partial withdrawals after three years.
<br></br>
Short term: Imarika investment plan is available from a term of 5 to 20 years. However, you can access your funds partially or in full from month 37 at no charge.
<br></br>
No withholding tax: Being a unit linked policy; your interest is not subjected to withholding tax. This means that members save 15% tax on the interest. Further, each group member can also use their policy number to apply for tax relief if the policy is 10 years or more.
<br></br>
Flexible contributions: each member has the option to increase or reduce your contributions at any time with no penalties, giving you the opportunity to control how you get to your final goal.





    </div>
  )
}

export default WhyImarikaChamaa